










































































































































































































































import Vue from 'vue'

const shortenNumber = (v: string | number): string => {
  const [first, ...rest] = v.toString().split('.')
  return [first.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'), ...rest.map(r => r.slice(0, 6))].join('.')
}

const canvas = document.createElement('canvas')
function getTextWidth (text: string, font: string): number {
  const context = canvas.getContext('2d')
  if (!context) {
    throw new Error('no canvas context')
  }
  context.font = font
  const metrics = context.measureText(text)
  return metrics.width
}

export default Vue.extend({
  data () {
    return {
      buffer: '0',
      nextTypeWillPush: false,
      nextTypeWillClear: false,
      stack: [] as number[],
      second: false,
    }
  },
  computed: {
    displayedBuffer (): string {
      return shortenNumber(this.buffer)
    },
    displayedStack (): string[] {
      return this.stack.map(shortenNumber)
    },
    bufferEmpty (): boolean {
      return this.buffer === '0'
    },
    bufferFontSize (): string {
      const textWidth = getTextWidth(this.displayedBuffer, '-apple-system, BlinkMacSystemFont, sans-serif')
      const screenWidth = document.body.clientWidth
      return screenWidth / textWidth * 9 + 'px'
    },
  },
  watch: {
    stack () {
      this.$nextTick(() => {
        const s = this.$refs.stack as HTMLDivElement
        s.scrollTop = s.scrollHeight
      })
    },
    buffer () {
      this.second = false
      this.$nextTick(() => {
        const s = this.$refs.buffer as HTMLDivElement
        s.scrollLeft = s.scrollWidth
      })
    },
  },
  methods: {
    clear () {
      this.buffer = '0'
      this.second = false
    },
    clearAll () {
      this.clear()
      this.stack = []
    },
    type (v: number | string) {
      if (this.nextTypeWillPush) {
        this.nextTypeWillPush = false
        this.stack.push(+this.buffer)
        this.clear()
      }

      if (this.nextTypeWillClear) {
        this.nextTypeWillClear = false
        this.clear()
      }

      if (typeof v === 'number') {
        this.buffer += v
      } else {
        if (v === '.' && !this.buffer.includes('.')) {
          this.buffer += '.'
        }
      }
      this.buffer = this.buffer.replace(/^0([^.])/, '$1')
    },
    push () {
      this.stack.push(parseFloat(this.buffer))
      this.nextTypeWillClear = true
    },
    toggleNegative () {
      this.buffer = (-this.buffer).toString()
    },
    add () {
      this.operation((a, b) => a + b)
    },
    subtract () {
      this.operation((a, b) => a - b)
    },
    multiply () {
      this.operation((a, b) => a * b)
    },
    divide () {
      this.operation((a, b) => a / b)
    },
    sqrt () {
      this.unaryOperation(a => Math.sqrt(a))
    },
    square () {
      this.unaryOperation(a => a * a)
    },
    power () {
      this.operation((a, b) => Math.pow(a, b))
    },
    rootn () {
      this.operation((a, b) => Math.pow(a, 1 / b))
    },
    unaryOperation (f: (a: number) => number) {
      const a = +this.buffer
      this.buffer = f(a).toString()
      this.nextTypeWillPush = true
    },
    operation (f: (a: number, b: number) => number) {
      const b = +this.buffer
      const a = this.stack.pop() || 0
      this.buffer = f(a, b).toString()
      this.nextTypeWillPush = true
    },
  },
})
